import UserActions from "../NipTypes";
import responseHandler from "../../utils/responseHandler";
import Instance from "../../utils/apiNip";
import Storage from "../../utils/storage";
import { failureTestFunction, startTestFunction, successTestFunction } from "../../utils/Functions/CheckFunction";

// INITIATE OUTWARD TEST
export const initiateTestStart = () => ({
    type: UserActions.INITIATE_OUTWARD_TEST_START
})

export const initiateTestSuccess = payload => ({
    type: UserActions.INITIATE_OUTWARD_TEST_SUCCESS,
    payload
})

export const initiateTestFailure = payload => ({
    type: UserActions.INITIATE_OUTWARD_TEST_FAILURE,
    payload
})

// RUN NAME ENQUIRY TEST
export const runNameEnquiryTestStart = () => ({
    type: UserActions.RUN_NAME_ENQUIRY_TEST_START
})

export const runNameEnquiryTestSuccess = payload => ({
    type: UserActions.RUN_NAME_ENQUIRY_TEST_SUCCESS,
    payload
})

export const runNameEnquiryTestFailure = payload => ({
    type: UserActions.RUN_NAME_ENQUIRY_TEST_FAILURE,
    payload
})

// RUN FUND TRANSFER TEST
export const runFundTransferTestStart = () => ({
    type: UserActions.RUN_FUND_TRANSFER_TEST_START
})

export const runFundTransferTestSuccess = payload => ({
    type: UserActions.RUN_FUND_TRANSFER_TEST_SUCCESS,
    payload
})

export const runFundTransferTestFailure = payload => ({
    type: UserActions.RUN_FUND_TRANSFER_TEST_FAILURE,
    payload
})

// RUN STATUS QUERY TEST
export const runStatusQueryTestStart = () => ({
    type: UserActions.RUN_STATUS_QUERY_TEST_START
})

export const runStatusQueryTestSuccess = payload => ({
    type: UserActions.RUN_STATUS_QUERY_TEST_SUCCESS,
    payload
})

export const runStatusQueryTestFailure = payload => ({
    type: UserActions.RUN_STATUS_QUERY_TEST_FAILURE,
    payload
})

// SUBMIT OUTWARD TEST
export const submitOutwardTestStart = () => ({
    type: UserActions.SUBMIT_OUTWARD_TEST_START
})

export const submitOutwardTestSuccess = payload => ({
    type: UserActions.SUBMIT_OUTWARD_TEST_SUCCESS,
    payload
})

export const submitOutwardTestFailure = payload => ({
    type: UserActions.SUBMIT_OUTWARD_TEST_FAILURE,
    payload
})

// CLEAR TEST STATE
export const clearNipTestState = () => ({
    type: UserActions.CLEAR_NIP_TEST_STATE,
});


export const initiateTest = (type, payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))
    dispatch(clearNipTestState())
    dispatch(initiateTestStart());
    API.post(type === "outward" ? `sandbox/integration/${type}/initiate-test`: `sandbox/integration/${type}/initiate`, payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(initiateTestSuccess(data));
        } else {
            dispatch(initiateTestFailure(data));
        }
    })
}

export const runOutwardTest = (name, payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    startTestFunction(name, dispatch);
    API.post(`sandbox/integration/outward/${name}`, payload).then((response) => {
        const {
            data,
            ok
        } = response;
        const success = data && data.data && data.data.status === "success"
        responseHandler(response);
        if (ok && success) {
            successTestFunction(name, dispatch, data);
        } else {
            failureTestFunction(name, dispatch, data);
        }
    })
}

export const submitOutwardTest = (payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(submitOutwardTestStart());
    API.post("sandbox/integration/inward-outward/submit", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(submitOutwardTestSuccess(data.data));
        } else {
            dispatch(submitOutwardTestFailure(data));
        }
    })
}